import {useEffect, useState} from "react";
import {KeycafeService} from "@hps/hops-sdk-js";
import {Select} from "Components/Select";
import {useSnackbarService} from "Services/useSnackbarService";
import {useFetch} from "Hooks/useFetch";

/**
 * Keycafe key picker
 *
 * Allows picking of keys in the Keycafe account of the active user's org.
 *
 * @param {Object} props
 * @return {ReactNode}
 */
export const KeycafeKeyPicker = props => {
	const {snack} = useSnackbarService();

	/**
	 * Select options
	 */
	const [options, setOptions] = useState([]);

	/**
	 * Fetch our keys
	 */
	const {data, loading, error} = useFetch({
		fn: () => KeycafeService.getKeys(),
		dep: []
	});

	/**
	 * Get our menu option objects
	 */
	useEffect(() => {

		if (data) {

			const options = [{
				label: "(None)",
				value: null
			}];

			for (const key of data) {
				options.push({
					label: key.Name,
					value: key.KeycafeId
				});
			}

			setOptions(options);

		}

	}, [data]);

	/**
	 * Error message to show when we failed to fetch data
	 */
	let errorMessage = undefined;

	/**
	 * We have an error with response data
	 */
	if (error?.response) {

		const status = error?.response?.status;

		if (status === 502) {

			const keycafeApiStatus = error?.response?.data?.Keycafe?.ApiStatus;
			const keycafeErrorId = error?.response?.data?.Keycafe?.ErrorId;

			if (keycafeApiStatus === 429) {
				errorMessage = "Error - Keycafe API rate limit exceeded. Please try again later.";
			}
			else {
				errorMessage = `Error - Keycafe API error. (${(keycafeApiStatus || "Unknown")}, ${(keycafeErrorId || "Unknown")})`;
			}

			snack(errorMessage, "error");
		}

	}

	/**
	 * Render!
	 */
	return (
		<Select
			disabled={props.disabled}
			loading={loading}
			error={error}
			name={props.name}
			onChange={props.onChange}
			options={options}
			required={props.required}
			value={props.value} />
	);

};
